__webpack_require__.p = "/ie-redirect-check/referrals/";